export const getFileExtension = (filename) => {
    return /(?:\.([^.]+))?$/.exec(filename)[1];
};
